import script from "./ModalListGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalListGroup.vue?vue&type=script&setup=true&lang=ts"

import "./ModalListGroup.vue?vue&type=style&index=0&id=b65365f6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b65365f6"]])

export default __exports__